import { IVersion, IFormattedVersion } from 'types/logs'
import { DISPLAY } from 'constants/display'

const convertDeeplyNestedObjectToAHumanReadableString = (obj: any): string =>
  JSON.stringify(obj, undefined, 1).replace(/"/g, '')

export const formatVersionChanges = (version: IVersion): IFormattedVersion[] =>
  Object.keys(version.changes).map(changeKey => {
    const change = version.changes[changeKey]
    const label = changeKey
      .replace(/_/g, ' ')
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase())
    const [beforeData, afterData] = change.map(c => c || DISPLAY.empty)

    const before = convertDeeplyNestedObjectToAHumanReadableString(beforeData)
    const after = convertDeeplyNestedObjectToAHumanReadableString(afterData)
    return { key: changeKey, label, before, after }
  })
